import './List.css'
import imsearch from '../../assets/images/hero.webp'
import { FaHome, FaSearch } from 'react-icons/fa'
import Card from '../../component/Card'
import { useEffect, useState } from 'react'
import { Link } from 'react-scroll'
import { Api } from '../../Api/Api'
import { toast } from "react-toastify";

const List = () => {

  const [primaryData, setPrimaryData] = useState([])
  const [data, setData] = useState([])
  const [fcity, setCity] = useState('all')
  const [fstate, setState] = useState('all')
  const [fprice, setPrice] = useState('all')


  useEffect(() => {
    loadData()
    window.scrollTo(0, 0)
  }, [])


  let loadData = () => {
    fetch(`${Api}/house`).then(res => {
      return res.json();
    }).then(res => {
      setData(res)
      setPrimaryData(res)

    }).catch((err) => {
      toast.error('Failed :' + err.message);
    });
  }

  let handleFilter = () => {
    // console.log(fcity, fstate, fprice)
    let newData = primaryData.filter((i) => {
      let con1 = fstate !== 'all' ? i.state === fstate : true
      let con2 = fprice !== 'all' ? i.price === fprice : true
      let con3 = fcity !== 'all' ? i.city === fcity : true

      return (con1 && con2 && con3)
    })

    // if (newData.length === 0) return "Sorry This Houses Not Available Now"
    setData(newData)

  }


  return (
    <div className="list">
      <img src={imsearch} alt="search" loading='lazy' />
      <div className="search">
        <div className="searchBox">
          <i><FaHome /></i>
          <div className="input">
            <label htmlFor="city">Choose a city:</label>
            <select id="city" name="city" value={fcity} onChange={(e) => { setCity(e.target.value) }}>
              <option value="all">All</option>
              <option value="homs">Homs</option>
              <option value="hama">Hama</option>
              <option value="damascus">Damascus</option>
            </select>
          </div>
        </div>

        <div className="searchBox">
          <i><FaHome /></i>
          <div className="input">
            <label htmlFor="state">Choose a state:</label>
            <select id="state" name="state" value={fstate} onChange={(e) => { setState(e.target.value) }}>
              <option value="all">All</option>
              <option value="For Sale">For Sale</option>
              <option value="For Rent">For Rent</option>
              <option value="For Mortgage">For Mortgage</option>
            </select>
          </div>
        </div>

        <div className="searchBox">
          <i><FaHome /></i>
          <div className="input">
            <label htmlFor="price">Choose a price:</label>
            <select id="price" name="price" value={fprice} onChange={(e) => { setPrice(e.target.value) }}>
              <option value="all">All</option>
              <option value="200$">200$</option>
              <option value="500$">500$</option>
              <option value="1000$">1000$</option>
              <option value="1500$">1500$</option>
              <option value="2000$">2000$</option>
              <option value="3000$">3000$</option>
              <option value="4000$">4000$</option>
              <option value="5000$">5000$</option>
              <option value="15000$">15000$</option>
              <option value="20000$">20000$</option>
              <option value="25000$">25000$</option>
            </select>
          </div>
        </div>
        <Link to='articles' onClick={handleFilter}><i><FaSearch /></i></Link>
      </div>
      <div className="articles" id="articles">
        <h5 className="main-title">List Of House</h5>
        {primaryData.length ?
          <div className="container">
            {data.length ? data.map((item, index) => (
              <Card key={index} data={item} />
            )) : "Sorry This house is not avilable now"}
          </div>
          : <div className="loading"></div>}
      </div >
    </div>
  )
}

export default List

